import * as React from "react";
import styled from "@mui/material/styles/styled";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { useScreenSize } from "../util/useScreenSize";

import { SectionTabSingle } from "./SectionTabSingle";

//region [[ Styles ]]

const SectionTabsView = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "start",
  backgroundColor: "white",
  justifyContent: "start",
  paddingTop: 0,
  paddingBottom: 0,
}));

const SectionContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  flexDirection: "column",
}));

const TabsContainer = styled("div")(({ theme }) => ({
  height: "88px",
  width: "100%",
  overflowY: "hidden",
}));

const Tabs = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  height: "100%",
}));

const RoundedSection = styled("div")(({ theme }) => ({
  height: "15px",
  width: "100%",

  display: "block",
  background: "white",
}));

const RoundCorners = styled("div")(({ theme }) => ({
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  "-webkit-filter": "drop-shadow(rgba(0, 0, 0, 0.2) 0px -1px 1px);",
  filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px -1px 1px)",

  height: "100%",
  width: "100%",
  background: RosebudColorMap.SecondaryLight,
}));

const SectionItem = styled("div")(
  ({ theme, selected }: { theme?: any; selected: boolean }) => ({
    paddingRight: "10px",
    fontSize: "36px",
    [theme.breakpoints.down(MobileView)]: {
      fontSize: selected ? "22px" : "16px",
    },
    color: selected ? RosebudColorMap.purple2 : "black",
    cursor: "pointer",
    fontWeight: 500,
    transition: "color 0.5s ease-in",
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SectionTabsProps {
  changeSection: (section: PatientCaseGrouping) => void;
  section: PatientCaseGrouping;
  showRoundedBottom: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SectionTabs = ({ ...props }: SectionTabsProps) => {
  const { isMobile } = useScreenSize();

  return (
    <SectionContainer className={"section-container"}>
      <SectionTabsView className={"section-tabs-view"}>
        {!isMobile && (
          <>
            <SectionItem
              selected={props.section === PatientCaseGrouping.BACKGROUND}
            >
              History
            </SectionItem>
            <SectionItem
              selected={props.section === PatientCaseGrouping.CLINICAL_FEATURES}
            >
              Clinical Findings
            </SectionItem>
            <SectionItem
              selected={props.section === PatientCaseGrouping.WORKUP}
            >
              Workup
            </SectionItem>
          </>
        )}
        {isMobile && (
          <TabsContainer className={"tab-container"}>
            <Tabs className={"tabs"}>
              <SectionTabSingle
                selected={
                  props.section === PatientCaseGrouping.CLINICAL_FEATURES
                }
                section={PatientCaseGrouping.CLINICAL_FEATURES}
                onClick={() =>
                  props.changeSection(PatientCaseGrouping.CLINICAL_FEATURES)
                }
              />
              <SectionTabSingle
                selected={props.section === PatientCaseGrouping.BACKGROUND}
                section={PatientCaseGrouping.BACKGROUND}
                onClick={() =>
                  props.changeSection(PatientCaseGrouping.BACKGROUND)
                }
              />
              <SectionTabSingle
                selected={props.section === PatientCaseGrouping.WORKUP}
                section={PatientCaseGrouping.WORKUP}
                onClick={() => props.changeSection(PatientCaseGrouping.WORKUP)}
              />
            </Tabs>
          </TabsContainer>
        )}
      </SectionTabsView>
      {props.showRoundedBottom && (
        <RoundedSection>
          <RoundCorners />
        </RoundedSection>
      )}
    </SectionContainer>
  );
};
